import { Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { Paper, Stack, Typography } from '@mui/material'
import PageContainer from '@/components/ui/containers/PageContainer'
import { ExpertiseMeetingsTable } from './ExpertiseMeetingsTable'
import { useExpertiseMeetings } from '../model/useExpertiseMeetings'
import { ShowMoreButton } from './ShowMoreButton'

export function ExpertiseMeetingsPage() {
  useLingui()
  const { data, hasNextPage, setNextPage } = useExpertiseMeetings()

  return (
    <PageContainer maxWidth="lg" sx={{ flex: 1 }}>
      <Paper sx={{ minHeight: '100%', p: 3 }}>
        <Stack spacing={3}>
          <Typography component="h1" sx={{ fontSize: '2.25rem', lineHeight: '2.5rem', fontWeight: 700 }}>
            <Trans>Expertise meetings</Trans>
          </Typography>

          <Stack direction="column" alignItems="center" justifyContent="center" spacing={2}>
            <ExpertiseMeetingsTable data={data} />
            <ShowMoreButton hasNextPage={hasNextPage} setNextPage={setNextPage} />
          </Stack>
        </Stack>
      </Paper>
    </PageContainer>
  )
}
